import * as z from "zod/v4";

export const imageDimensionsSchema = z.object({
  height: z.number(),
  width: z.number(),
});
export type ImageDimensions = z.infer<typeof imageDimensionsSchema>;

/* Product Image Aspect Ratios */

export const productImageAspectRatios = [
  "THREE_BY_TWO",
  "SQUARE",
  "FOUR_BY_FIVE",
  "TWO_BY_THREE",
] as const;

export type ProductImageAspectRatio = (typeof productImageAspectRatios)[number];

export const ProductImageAspectRatio = {
  THREE_BY_TWO: 3 / 2,
  SQUARE: 1,
  FOUR_BY_FIVE: 4 / 5,
  TWO_BY_THREE: 2 / 3,
} as const satisfies Record<ProductImageAspectRatio, number>;

export const aspectRatioFriendly = {
  THREE_BY_TWO: "3:2",
  SQUARE: "1:1",
  FOUR_BY_FIVE: "4:5",
  TWO_BY_THREE: "2:3",
} as const satisfies Record<ProductImageAspectRatio, string>;

export function numberToProductImageAspectRatio(
  aspectRatio?: number,
): ProductImageAspectRatio {
  if (aspectRatio === undefined) {
    return "SQUARE";
  }
  return (Object.entries(ProductImageAspectRatio).find(
    ([key, value]) => value === aspectRatio,
  )?.[0] ?? "SQUARE") as ProductImageAspectRatio;
}

/**
 * These teams have made the rare decision to prioritize product images over variant images in the OT tracking page and emails.
 * Unlikely to ever be needed again, hence the hardcoding.
 *
 * This is because their product featured image is a model posing with the wig, and all the variant images are just the wig on a white background.
 * Right now, our manually selected products selector for email products blocks must be given a specific variant of a product,
 * even if the merchant selects the checkbox for the entire product, so it just chooses the first variant, thus showing the first variant image.
 *
 * A more robust solution would probably involve updating the products block to allow for selecting the entire product. Non trivial, since then we'd have to
 * figure out what to do with price ranges, etc. So for now, hardcoding.
 *
 * Update Oct 2025 - the fact that this has come up 4 times means we should probably... softcode this?
 */
export const TEAMS_THAT_PRIORITIZE_PRODUCT_OVER_VARIANT_IMAGES = [
  "6762fcc88af53306bdd80250", // wigs outlet
  "67e463f121ee9d8379f4fc3b", // wigs.com
  "656a2bbd0433410007cb4c80", // Wig Studio 1
  "67352b7fd92b966a56a98f36", // Abstract Ocean
  "64f9d65cdd78c2000777d69a", // National Body Armor
];
